<template>
  <!-- 上线 -->
  <div
    id="multiSensorHiL"
    :class="{
      box: true,
      'landscape-box': isLandscape,
      'portrait-box': !isLandscape,
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="multiSensorHiLModule1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="multiSensorHiLModule1Text">
        <div id="multiSensorHiLModule1TextText1" class="module1">
          {{ $t("productCenterDriveView").content.h1 }}
        </div>
        <div id="multiSensorHiLModule1TextText2" class="module1">
          {{ $t("productCenterDriveView").content.h2 }}
        </div>
      </div>
    </div>
    <div id="coteent">
      <div id="driverRingModuleTwo">
        <div id="closedLoopExperience">
          <div id="closedLoopExperienceTop">
            <div
              id="closedLoopExperienceTopTitle"
              class="wow animate__animated animate__fadeInUp"
            >
              {{ $t("productCenterDriveView").content.h3 }}
            </div>
            <div
              id="closedLoopExperienceTopContent"
              class="wow animate__animated animate__fadeInUp"
            >
              <!-- {{ $t("productCenterDriveView").content.h4 }} -->
            </div>
          </div>
          <div id="closedLoopExperienceBottom">
            <div
              id="closedLoopExperienceBottomLeft"
              class="wow animate__animated animate__fadeInUp"
            >
              <img
                :src="$t('productCenterDriveView.content.driveLoopImg')"
                alt=""
              />
            </div>
            <div
              id="closedLoopExperienceBottomRight"
              class="wow animate__animated animate__fadeInUp"
            >
              <div id="closedLoopExperienceBottomRightDetailText">
                <div id="closedLoopExperienceBottomRightDetail">
                  <div id="closedLoopExperienceBottomRightImg">
                    <img src="@/static/img/driverTaxi.png" alt="" />
                  </div>
                  <div id="closedLoopExperienceBottomRightDetailRight">
                    <div id="closedLoopExperienceBottomRightDetailRightTitle">
                      {{ $t("productCenterDriveView").content.h5 }}
                    </div>
                    <div id="closedLoopExperienceBottomRightDetailRightText">
                      {{ $t("productCenterDriveView").content.h6 }}
                    </div>
                  </div>
                </div>
                <div id="closedLoopExperienceBottomRightDetail">
                  <div
                    id="closedLoopExperienceBottomRightImg"
                    class="driverFlowersImg"
                  >
                    <img src="@/static/img/driverFlowers.png" alt="" />
                  </div>
                  <div id="closedLoopExperienceBottomRightDetailRight">
                    <div id="closedLoopExperienceBottomRightDetailRightTitle">
                      {{ $t("productCenterDriveView").content.h7 }}
                    </div>
                    <div id="closedLoopExperienceBottomRightDetailRightText">
                      {{ $t("productCenterDriveView").content.h8 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="driverRingThree"
        :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
        v-lazy="imageUrl2"
      >
        <div id="driverRingThreeContent">
          <div
            id="driverRingThreeContentTextTop"
            class="wow animate__animated animate__fadeInUp"
          >
            {{ $t("productCenterDriveView").content.h9 }}
          </div>
          <div
            id="driverRingThreeContentTextBottom"
            class="wow animate__animated animate__fadeInUp"
          >
            {{ $t("productCenterDriveView").content.h10 }}
          </div>
        </div>
      </div>
      <!-- 驾驶员在环解决方案 -->
      <div class="driveSolution">
        <div class="left wow animate__animated animate__fadeInUp">
          <div class="h1">
            {{ $t("productCenterDriveView.driveSolution.title") }}
          </div>
          <div class="h2">
            {{ $t("productCenterDriveView.driveSolution.content") }}
          </div>
        </div>
        <div class="right wow animate__animated animate__fadeInUp">
          <img src="@/static/img/driveImg.png" alt="" srcset="" />
        </div>
      </div>
      <div class="table">
        <div
          class="table1 wow animate__animated animate__fadeInUp"
          ref="driveSolutionTable1Element"
        >
          <ul>
            <div class="title">
              {{ $t("productCenterDriveView.benchmark.parameters.title") }}
            </div>
            <li v-for="(item, index) in tableData.table1" :key="index">
              <div class="left">
                {{
                  $t(
                    `productCenterDriveView.benchmark.parameters.content.${item.key}`
                  )
                }}
              </div>
              <div class="right">{{ item.value }}</div>
            </li>
          </ul>
        </div>
        <div
          class="table1 table2 wow animate__animated animate__fadeInUp"
          style="animation-duration: 1.5s !important"
          ref="driveSolutionTable2Element"
        >
          <ul>
            <div class="title">
              {{ $t("productCenterDriveView.benchmark.performance.title") }}
            </div>
            <li v-for="(item, index) in tableData.table2" :key="index">
              <div class="left">
                {{
                  $t(
                    `productCenterDriveView.benchmark.performance.content.${item.key}`
                  )
                }}
              </div>
              <div class="right">{{ item.value }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div id="DriverRingFooter">
        <FooterComponents></FooterComponents>
      </div>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";

export default {
  computed: {
    isLandscape() {
      return Math.abs(window.orientation) === 90;
    },
  },
  components: {
    FooterComponents,
  },
  data() {
    return {
      imageUrl1: require("@/static/img/driverBanner.png"),
      imageUrl2: require("@/static/img/driverLoopsolutionBg.png"),
      imageUrl3: require("@/static/img/HiLArrow.png"),
      imageUrl4: require("@/static/img/HilColorCol.png"),
      imageUrl5: require("@/static/img/HilColorBox.png"),
      imageUrl6: require("@/static/img/HiLRowBg.png"),
      imageUrl7: require("@/static/img/HiLProductBg.png"),
      tableData: {
        table1: [
          {
            key: "effectiveLoadCapacity",
            value: "200Kg",
          },
          {
            key: "longitudinalDisplacement",
            value: "+/-360mm",
          },
          {
            key: "lateralDisplacement",
            value: "+/-360mm",
          },
          {
            key: "verticalLift",
            value: "0-400mm",
          },
          {
            key: "pitch",
            value: "+/-20deg",
          },
          {
            key: "roll",
            value: "+/-20deg",
          },
          {
            key: "yaw",
            value: "+/-22deg",
          },
          {
            key: "operationalNoiseLevel",
            value: "<65dB",
          },
        ],
        table2: [
          {
            key: "linearVelocity",
            value: "300mm/s",
          },
          {
            key: "linearAcceleration",
            value: "0.4g",
          },
          {
            key: "angularVelocity",
            value: "20°/s",
          },
          {
            key: "angularAcceleration",
            value: "150°/s²",
          },
          {
            key: "responseTime",
            value: "< 0.2s",
          },
          {
            key: "key",
            value: "v",
          },
        ],
      },
    };
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.landscape-box {
  /* 横屏 */
  /* display: flex;
  flex-direction: column; */
}

.portrait-box {
  /* 竖屏 */
  display: flex;
  flex-direction: column;
}

#multiSensorHiL {
  width: 100%;
  height: 100%;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #multiSensorHiLModule1 {
    background-size: cover;
    @include whar(100%, auto, 1440/480);
    padding: 12.9375rem 0rem 11rem 12.8125rem;

    #multiSensorHiLModule1Text {
      width: fit-content;
      height: 7.75rem;
      line-height: 3.875rem;

      #multiSensorHiLModule1TextText1 {
        @include fontStyle(
          600,
          3.875rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
      }

      #multiSensorHiLModule1TextText2 {
        opacity: 1;
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  #coteent {
    flex: 1;
    display: flex;
    flex-direction: column;

    /* background-color: red; */
    #driverRingModuleTwo {
      width: 100%;
      flex: 0.5;
      padding: 4.875rem 0 0 0;
      /* @include whar(100%, auto, 1440/742); */
      @include display;

      #closedLoopExperience {
        margin: auto;
        display: flex;
        // height: 41.5rem;
        width: 60.625rem;
        flex-direction: column;

        #closedLoopExperienceTop {
          // height: 7.375rem;

          #closedLoopExperienceTopTitle {
            text-align: center;
            @include fontStyle(
              600,
              3.125rem,
              2.25rem,
              3.125rem,
              0.06944rem,
              rgba(255, 255, 255, 0.85)
            );
            //顺序不能变
            width: 100%;
          }

          #closedLoopExperienceTopContent {
            margin-top: 1rem;
            text-align: center;
            @include fontStyle(
              400,
              1.625rem,
              1rem,
              1.625rem,
              0.06944rem,
              rgba(255, 255, 255, 0.65)
            );
          }
        }

        #closedLoopExperienceBottom {
          flex: 1;
          display: flex;
          align-items: center;
          /* background-color: yellow; */

          #closedLoopExperienceBottomLeft {
            align-self: end;
            width: 29.125rem;
            height: 30.625rem;

            img {
              width: 29.125rem;
              height: 30.625rem;
              object-fit: cover;
            }
          }

          #closedLoopExperienceBottomRight {
            margin: auto;
            margin-left: 4.6875rem;
            /* background-color: green; */

            #closedLoopExperienceBottomRightDetailText {
              display: flex;
              width: 28.5rem;
              flex-direction: column;
              justify-content: space-between;
              /* background-color: rgb(111, 23, 253); */

              #closedLoopExperienceBottomRightDetail {
                margin-bottom: 3rem;
              }

              #closedLoopExperienceBottomRightDetail {
                display: flex;
                box-sizing: border-box;

                #closedLoopExperienceBottomRightImg {
                  flex: 1;

                  img {
                    width: 2rem;
                    height: 2rem;
                    object-fit: cover;
                  }
                }

                .driverFlowersImg {
                  padding-top: 0.18rem;
                }

                #closedLoopExperienceBottomRightDetailRight {
                  width: 25.75rem;

                  #closedLoopExperienceBottomRightDetailRightTitle {
                    /* background-color: red; */
                    margin-bottom: 0.25rem;
                    @include fontStyle(
                      600,
                      auto,
                      1.5rem,
                      auto,
                      0.06944rem,
                      rgba(255, 255, 255, 0.85)
                    );
                  }

                  #closedLoopExperienceBottomRightDetailRightText {
                    /* background-color: rgb(154, 89, 207); */
                    @include fontStyle(
                      400,
                      auto,
                      0.875rem,
                      auto,
                      0.06944rem,
                      rgba(255, 255, 255, 0.65)
                    );
                  }
                }
              }
            }
          }
        }
      }
    }

    #driverRingThree {
      flex: 0.5;
      height: 10rem !important;
      width: 100%;
      @include display;
      background-size: cover;
      background-position: center center;
      padding: 6.5625rem 0;

      #driverRingThreeContent {
        display: flex;
        flex-direction: column;
        align-items: center;

        #driverRingThreeContentTextTop {
          @include fontStyle(
            600,
            100%,
            2.25rem,
            3.125rem,
            0.06944rem,
            rgba(255, 255, 255, 0.85)
          );
        }

        #driverRingThreeContentTextBottom {
          @include fontStyle(
            400,
            1.625rem,
            1rem,
            1.625rem,
            0.06944rem,
            rgba(255, 255, 255, 0.65)
          );
          margin-top: 1rem;
        }

        #driverRingThreeContentText {
          display: flex;
          /* height: 5.75rem; */
          box-sizing: border-box;
          /* width: 25.875rem; */
          margin-right: 11.25rem;
          flex-direction: column;
          justify-content: space-between;
          background-color: blue;

          #driverRingThreeContentTextTop {
            @include fontStyle(
              600,
              100%,
              2.25rem,
              3.125rem,
              0.06944rem,
              rgba(255, 255, 255, 0.85)
            );
            /* background-color: red; */
          }

          #driverRingThreeContentTextBottom {
            @include fontStyle(
              400,
              1.625rem,
              1rem,
              1.625rem,
              0.06944rem,
              rgba(255, 255, 255, 0.65)
            );
            margin-top: 1rem;
          }
        }

        #driverRingThreeContentImg {
          width: 23.3125rem;
          height: 25.75rem;
          /* background-color: red; */
          margin-top: 7rem;

          img {
            width: 23.3125rem;
            height: 25.75rem;
            object-fit: cover;
          }
        }
      }
    }

    .driveSolution {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16rem;
      height: 34.25rem;
      background: url("@/static/img/driveSolution_bg.png") no-repeat 100% 100%;
      background-size: contain;

      .left {
        width: 31.6875rem;

        .h1 {
          color: rgba(255, 255, 255, 0.85);
          font-size: 1.5rem;
          font-style: normal;
          font-weight: 600;
          line-height: 2.5rem;
          margin-bottom: 1.25rem;
        }

        .h2 {
          color: rgba(255, 255, 255, 0.65);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 1.625rem;
        }
      }

      .right {
        width: 19.0546rem;
        height: 21.2874rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .table {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 5.3125rem 12.25rem;

      .table1 {
        width: 50%;

        ul {
          .title {
            height: 3.5rem;
            text-align: center;
            line-height: 3.5rem;
            border-radius: 0.25rem 0.25rem 0rem 0rem;
            border: 0.0625rem solid var(--Neutral-gray-500, #282d45);
            background: var(--Neutral-gray-800, #0e1330);
            color: #fff;
            font-size: 1rem;
            font-style: normal;
            font-weight: 500;
          }

          li {
            display: flex;
            justify-content: center;

            .left,
            .right {
              width: 50%;
              padding: 0.65rem 2rem;
              border: 0.0625rem solid var(--Neutral-gray-500, #282d45);
              color: #fff;
              font-size: 0.875rem;
              font-style: normal;
              font-weight: 400;
            }

            .left {
              border-right: none;
              border-top: none;
            }

            .right {
              border-top: none;
            }

            background-color: #0e1330;

            &:nth-child(odd) {
              background-color: #131938;
            }
          }
        }
      }

      .table2 {
        margin-left: 1.5rem;

        ul {
          li {
            &:nth-child(6),
            &:nth-child(7) {
              background-color: transparent;

              .left,
              .right {
                padding: 1.9rem 2rem;
              }
            }

            &:last-child {
              .left,
              .right {
                color: transparent;
                padding: 1.9rem 2rem;
              }
            }
          }
        }
      }
    }

    #DriverRingFooter {
      width: 100%;
      height: 18rem;
    }
  }

  &.en {
    #closedLoopExperienceBottomRightDetailRightText {
      // text-align: justify !important;
      margin-top: 0.5rem !important;
    }
    .driveSolution {
      .h1,
      .h2 {
        line-height: 1.5 !important;
      }
      // .h2 {
      //   text-align: justify !important;
      // }
    }
  }
}
</style>
